export enum AccessTypeSecurity {
    entrance = 1,
    exit = 2
}
